import { LaneType } from 'common-types';

import { isProbablyUUID, isProbablyMongoId, convertTo62 } from 'uuid-encoding';

import { ENVIRONMENTS } from 'constants-activate';
import { toEnum } from '../interfaceObjects/commonFunctions';

export const MEDIA_URLS = {
  [ENVIRONMENTS.PRODUCTION]: 'assets.activate.vts.com',
  [ENVIRONMENTS.STAGING]: 'assets.s.activate.vts.com',
  [ENVIRONMENTS.DEMO]: 'assets.d.activate.vts.com',
  [ENVIRONMENTS.DEVELOPMENT]: 'assets.d.activate.vts.com',
  [ENVIRONMENTS.PREVIEW]: 'assets.d.activate.vts.com',
  [ENVIRONMENTS.ESSENSYS]: 'assets.d.activate.vts.com',
  [ENVIRONMENTS.LOCAL]: 'assets.d.activate.vts.com',
  [ENVIRONMENTS.TEST]: 'assets.d.activate.vts.com',
};

/**
 * Gets the full URL of a Media.  It supports legacy media that were uploaded
 * in v4 and have an shorter MongoIDs
 *
 * Any new media with a longer ID will have a slightly different URL.
 */
const defaultOptions = {
  notFromCache: false,
  suffix: 'media',
};

export function getMediaUrl(
  media:
    | LaneType.UUID
    | {
        _id: LaneType.UUID;
        previewUrl?: string | undefined | null;
      }
    | null
    | undefined,
  options?: {
    notFromCache?: boolean;
    suffix?: string; // suffix should be mandatory in v2
    privateS3MediaEnabled?: boolean;
  }
): string {
  const resultOptions = { ...defaultOptions, ...options };

  if (!media) {
    // TODO: default to a place holder image?
    return '';
  }

  // add notFromCache parameter
  let parameter = '';

  if (resultOptions.notFromCache) {
    parameter = '?not-from-cache-please';
  }

  // check to see if this is an object being passed in.
  const id = typeof media === 'string' ? media : media._id;

  if (options?.privateS3MediaEnabled) {
    const previewUrl =
      typeof media === 'object' && media?.previewUrl ? media.previewUrl : '';

    if (previewUrl) return previewUrl;
  }

  if (isProbablyMongoId(id)) {
    // Legacy v4 image format.
    return `https://mona-production.s3.amazonaws.com/${id}.image${parameter}`;
  }

  const appEnv = process.env.APP_ENV;

  if (!appEnv) {
    throw Error('APP_ENV is not available as an environment variable');
  }

  const assetsURL = MEDIA_URLS[toEnum(appEnv, ENVIRONMENTS)];
  let prefix = `https://${assetsURL}`;

  // this is probably a Media id.
  if (isProbablyUUID(id)) {
    if (options?.privateS3MediaEnabled) {
      prefix = `https://${assetsURL}/attachments`;
    }

    return `${prefix}/${convertTo62(id)}.${resultOptions.suffix}${parameter}`;
  }

  // if it doesn't match any of the above format's this is probably an SVG
  // we do not allow sftp, ssh, ftp, http, https so we can defend against
  // SSRF attacks. See `lane-server/src/routes/api/v5/media.ts`.
  return id;
}
